import { createContext } from 'react';

import { HoneycombColorMetadataContextProps } from '../types/rendering.js';

export const HoneycombColorMetadataContext =
  createContext<HoneycombColorMetadataContextProps>({
    tileData: [],
    colorMetadata: new WeakMap(),
  });

HoneycombColorMetadataContext['displayName'] = 'HoneycombColorMetadataContext';
